import React from 'react';
import {Box, Typography} from '@mui/material';
import {format, isToday} from 'date-fns';
import {Event} from './Event';
import DayRotaSummary from './DayRotaSummary';

export default function AgendaList({events = [], mode, rota, onDelete, compact}) {
  const days = events.filter(day => mode !== 'month' || day.inCurrentMonth !== false);
  return <Box sx={{display: 'grid', gap: 2, minWidth: 0}}>
    {days.map(day => {
      const dayEvents = day.events.filter(event => !event.spacer)
        .sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
      const label = format(day.date, 'EEEE do MMM');
      return <Box component="section" aria-label={label} key={day.date}
        sx={{minWidth: 0, borderTop: '1px solid #ccc', p: 1, bgcolor: isToday(day.date) ? '#e8f2e9' : 'transparent'}}>
        <Typography component="h2" variant="subtitle2" sx={{mb: 1}}>{label}</Typography>
        {rota && <DayRotaSummary summary={rota.days[format(day.date, 'yyyy-MM-dd')]} loading={rota.loading} error={rota.error} />}
        <Box sx={{display: 'grid', gap: 1, minWidth: 0}}>
          {dayEvents.map(event => <Event key={event._id} event={event} dateIndex={0} agenda compact={compact} onDelete={onDelete} />)}
          {!dayEvents.length && <Typography variant="caption" color="text.secondary">No events.</Typography>}
        </Box>
      </Box>;
    })}
    {!days.length && <Typography variant="body2">No days to display.</Typography>}
  </Box>;
}
